import Phaser from "phaser";
import { GAME_CONFIG, COLORS } from "../config";
import { findLevelByPassword, LEVELS } from "../data/levelData";

export class HomeScene extends Phaser.Scene {
  constructor() {
    super({ key: "HomeScene" });
  }

  preload(): void {
    // Load background image
    this.load.image("home-bg", "images/game-bg.png");
  }

  create(): void {
    const width = 1024;
    const height = 768;

    // Resize canvas to 1024x768
    this.scale.resize(width, height);

    // Display background centered
    this.add.image(512, 384, "home-bg").setOrigin(0.5);

    // Create visible clickable regions over the buttons in the background image (DEBUG MODE)

    // START button region - left button (x: 85-450)
    const startButton = this.add.rectangle(210, 670, 300, 120, 0xff0000, 0);
    startButton.setInteractive({ useHandCursor: true });

    startButton.on("pointerdown", () => {
      console.log("START clicked!");
      this.startGame(0);
    });

    // PASSWORD button region - middle button (x: 480-815)
    const passwordButton = this.add.rectangle(520, 670, 300, 120, 0xff0000, 0);
    passwordButton.setInteractive({ useHandCursor: true });

    passwordButton.on("pointerdown", () => {
      console.log("PASSWORD clicked!");
      this.scene.start("PasswordScene");
    });

    // "How to play" button region - right button (x: 850-1180)
    const editor = this.add.rectangle(830, 670, 300, 120, 0xff0000, 0);
    editor.setInteractive({ useHandCursor: true });

    editor.on("pointerdown", () => {
      // go to /editor.html
      window.location.href = "/editor.html";
    });

    // Keyboard input - Space to start
    this.input.keyboard?.on("keydown", (event: KeyboardEvent) => {
      if (event.code === "Space") {
        this.startGame(0);
      }
    });
  }

  private startGame(levelIndex: number): void {
    // Store the starting level index
    (window as any).__startLevelIndex = levelIndex;
    this.scene.start("GameScene");
  }
}
